const appInfo = {
    title: 'Beertime'
};
export default appInfo;

